import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";
import ArrowDownSignToNavigate from "src/img/arrow-down-sign-to-navigate.svg";

export const FormRow = styled.div`
    margin: 1em 0 1.9em 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
`;

export const FormFieldContainer = styled.div`
    font-family: Manrope, Helvetica, sans-serif;

    label {
        font-size: 14px;
        font-weight: 700;
        margin-right: 1em;
    }
`;

export const FormDescription = styled.div`
    font-size: 14px;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 500;
    color: ${portalColors.mutedText};
`;

export const FieldLabelContainer = styled.div`
    label {
        font-size: 14px;
        font-family: Manrope, Helvetica, sans-serif;
        font-weight: 700;
        margin: 0 0 15px 0;
    }
`;

export const FormSelect = styled.select`
    height: 42px;
    width: ${p => p.width || "15em"};
    max-width: 100%;
    border-radius: 8px;
    background: ${portalColors.surfaceSoft} 0 0 no-repeat padding-box;
    box-shadow: none;
    border: 1px solid ${portalColors.border};
    padding: 0.3em 1.1em;
    color: ${portalColors.text};
    font-size: 0.875rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 700;
    background-image: url(${ArrowDownSignToNavigate});
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;

    &:focus,
    &:focus-visible {
        outline: none;
        border-color: ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    }

    &:disabled {
        background-color: ${portalColors.surfaceTertiary};
        color: ${portalColors.textSoft};
        cursor: not-allowed;
    }
`;
